import React from "react";

import classes from "./style.module.scss";

const SHARE_TICKS = ["0%", "25%", "50%", "75%", "100%"];
const MEAN_ABS_AXIS_MAX = 0.3;
const MEAN_ABS_TICKS = ["0%", "0.10%", "0.20%", "0.30%"];

const Scale = ({ ticks }) => (
    <div className={classes.scale} aria-hidden="true">
        <span />
        <span className={classes.ticks}>
            {ticks.map((tick) => (
                <span key={tick}>{tick}</span>
            ))}
        </span>
        <span />
    </div>
);

const Track = ({ width, tone = "primary" }) => (
    <span className={classes.track} aria-hidden="true">
        <span
            className={tone === "secondary" ? classes.fillSecondary : classes.fill}
            style={{ width: `${width}%` }}
        />
    </span>
);

export const ToleranceBandChart = ({ rows }) => (
    <figure className={classes.figure}>
        <figcaption>Share of 5,820 paired files inside each total-consumption band</figcaption>
        <div className={classes.plot} role="list">
            {rows.map((row) => (
                <div className={classes.barRow} role="listitem" key={row.band}>
                    <span className={classes.barLabel}>{row.band}</span>
                    <Track width={row.shareValue} />
                    <span className={classes.barValue}>{row.share}</span>
                </div>
            ))}
        </div>
        <Scale ticks={SHARE_TICKS} />
    </figure>
);

export const MeanAbsoluteChart = ({ rows }) => (
    <figure className={classes.figure}>
        <figcaption>Mean absolute difference by end use</figcaption>
        <div className={classes.plot} role="list">
            {rows.map((row) => (
                <div className={classes.barRow} role="listitem" key={row.name}>
                    <span className={classes.barLabel}>{row.name}</span>
                    <Track width={(row.meanAbsValue / MEAN_ABS_AXIS_MAX) * 100} />
                    <span className={classes.barValue}>{row.meanAbs}</span>
                </div>
            ))}
        </div>
        <Scale ticks={MEAN_ABS_TICKS} />
    </figure>
);

export const WithinBandChart = ({ rows }) => (
    <figure className={classes.figure}>
        <figcaption>Share of files within ±1% and within ±5%, by end use</figcaption>
        <div className={classes.legend} aria-hidden="true">
            <span className={classes.legendItem}>
                <span className={classes.swatch} /> Within ±1%
            </span>
            <span className={classes.legendItem}>
                <span className={`${classes.swatch} ${classes.swatchSecondary}`} /> Within ±5%
            </span>
        </div>
        <div className={classes.plot} role="list">
            {rows.map((row) => (
                <div className={classes.group} role="listitem" key={row.name}>
                    <span className={classes.barLabel}>{row.name}</span>
                    <Track width={row.within1Value} />
                    <span className={classes.barValue}>
                        <span className={classes.srOnly}>Within ±1% </span>
                        {row.within1}
                    </span>
                    <Track width={row.within5Value} tone="secondary" />
                    <span className={classes.barValue}>
                        <span className={classes.srOnly}>Within ±5% </span>
                        {row.within5}
                    </span>
                </div>
            ))}
        </div>
        <Scale ticks={SHARE_TICKS} />
    </figure>
);
